import { AxiosInstance } from "axios";
import { Rapport, RapportIndicateur } from "../types/Rapport";
import { Indicateur } from "../types/Indicateur";

type CreateRapportWithIndicateursResult = {
  success: boolean;
  rapport?: Rapport;
  message?: string;
};

export const rapportService = {
  getAllRapports: async (api: AxiosInstance): Promise<Rapport[]> => {
    try {
      const response = await api.get("/rapport");
      return response.data as Rapport[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des rapports :", error);
      return [];
    }
  },

  getRapportById: async (
    api: AxiosInstance,
    idRapport: number
  ): Promise<Rapport | null> => {
    try {
      const response = await api.get(`/rapport/${idRapport}`);

      if (response.data?.success === false) {
        return null;
      }

      return response.data as Rapport;
    } catch (error: any) {
      console.error("Erreur lors de la récupération du rapport :", error);
      return null;
    }
  },

  createRapport: async (api: AxiosInstance, rapport: Partial<Rapport>): Promise<Rapport | null> => {
    try {
        const response = await api.post("/rapport/create", rapport);

        if (!response.data || response.data.success === false) {
        console.error("Erreur backend:", response.data?.message);
        return null;
        }

        return response.data.rapport as Rapport;
    } catch (error: any) {
        console.error("Erreur lors de la création du rapport :", error);
        return null;
    }
    },

  getIndicateursByRapport: async (api: AxiosInstance, idRapport: number): Promise<Indicateur[]> => {
    try {
      const response = await api.get(`/rapport/${idRapport}/indicateurs`);
      return response.data as Indicateur[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des indicateurs :", error);
      return [];
    }
  },

  addIndicateurToRapport: async (
    api: AxiosInstance,
    rapportIndicateur: Partial<RapportIndicateur>
  ): Promise<RapportIndicateur | null> => {
    try {
      const response = await api.post("/rapport/indicateur/add", rapportIndicateur);
      if (response.data?.success === false) return null;
      return response.data.rapportIndicateur as RapportIndicateur;
    } catch (error: any) {
      console.error("Erreur lors de l'ajout de l'indicateur au rapport :", error);
      return null;
    }
  },

  updateDescription: async (
    api: AxiosInstance,
    idRapport: number,
    description: string
    ): Promise<boolean> => {
    try {
        const response = await api.put(`/rapport/${idRapport}/description`, { description });
        return response.data?.success === true;
    } catch (error: any) {
        console.error("Erreur lors de la mise à jour de la description :", error);
        return false;
    }
    },

  createRapportWithIndicateurs: async (
    api: AxiosInstance,
    indicateursChoisis: Indicateur[],
    tableName: string,
    description?: string
  ): Promise<CreateRapportWithIndicateursResult> => {
    try {
      if (!api) {
        return {
          success: false,
          message: "API non disponible",
        };
      }
      
      const createResult = await rapportService.createRapport(api, {
        titre: tableName,
        description: description
      });

      if (createResult===null) {
        return {
          success: false,
          message: "Échec création du rapport",
        };
      }

      const rapport = createResult;

      const addPromises = indicateursChoisis.map((ind) =>
        rapportService.addIndicateurToRapport(api, {
          idRapport: rapport.idRapport,
          idIndicateur: ind.id,
          isActive: true,
        })
      );

      const results = await Promise.all(addPromises);

      const failed = results.some((res) => res === null);

      if (failed) {
        return {
          success: false,
          message: "Certains indicateurs n'ont pas pu être ajoutés",
        };
      }

      return {
        success: true,
        rapport,
      };

    } catch (error) {
      console.error(
        "Erreur lors de la création du rapport avec indicateurs :",
        error
      );

      return {
        success: false,
        message: "Erreur serveur ou réseau",
      };
    }
  },

};